import { useEffect, useState } from "react";

import { getEmailReplies } from "./misc/constants";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";

const useEmail = () => {
    const { clientId, platformId } = useParams();
    const [emails, setEmails] = useState({
        data : [],
        token: ""
    });
    const [activeEmail, setActiveEmail] = useState(null);
    const { axiosInstance, loading } = useAxios({ base: "panel", initialLoader: true });

    const getAllEmails = async () => {

        const { data = [], next_page_token } = await axiosInstance.get(`/gmail/${platformId}/read`, {
            params: {
                org_id: clientId,
                ...(size(emails.token) ? { next_page_token: emails.token } : {})
            }
        });
        if (data) {
            setEmails({
                data,
                token: next_page_token
            }); 
            setActiveEmail(data[0]);
        }
    };

    const handleActiveEmail = (email) => {
        setActiveEmail(email);
    };

    const getEmailThread = () => {
        if (activeEmail) {
            const thread = getEmailReplies(emails, activeEmail.thread_id);
            if (size(thread)) {
                return [activeEmail, ...thread];
            }
            return [activeEmail];
        }
    };

    useEffect(() => {
        getAllEmails();
    }, []);

    return {
        loading,
        emails,
        handleActiveEmail,
        activeEmail,
        getAllEmails,
        getEmailThread
    };
};

export default useEmail;